var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverhaulDuei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "parent",
    height: "parent",
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overhaul"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3631 101.879H3.37109V106.822H27.3631V101.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.8252 92.289L11.7098 85.6816H19.4626L20.7096 92.289H9.8252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3672 84.9564L14.1038 75.6406H16.784L19.1708 84.9564H11.3672Z",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.26872 93.0564L7.26562 101.238H23.313L21.1632 92.7969L9.26872 93.0564Z",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.5429 52.575C12.5429 52.575 9.53548 60.6777 16.3686 63.1153C15.6463 67.838 19.2632 70.6029 24.0706 71.579C23.9465 61.0952 15.7366 52.3945 12.5429 52.575Z",
    fill: "#FAFFE6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8319 66.71C17.3228 70.0109 25.2166 73.6559 35.9431 71.7883C36.1537 69.3694 35.9165 66.9325 35.2434 64.5997C34.3293 61.3101 32.5801 58.7823 29.409 56.277C26.8135 54.2287 23.4223 52.7278 20.8606 50.8037C19.3936 49.6752 17.9886 48.5467 16.6513 47.3336C16.325 47.0426 15.9247 46.8474 15.4946 46.7693C14.9673 46.6482 14.414 46.7235 13.9383 46.9811C13.4625 47.2387 13.097 47.6609 12.9103 48.1687C12.4279 49.3389 12.3407 50.6346 12.662 51.8589C13.4689 54.9453 15.551 57.2926 20.5164 57.7384",
    fill: "#FAFFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8319 66.71C17.3228 70.0109 25.2166 73.6559 35.9431 71.7883C36.1537 69.3694 35.9165 66.9325 35.2434 64.5997C34.3293 61.3101 32.5801 58.7823 29.409 56.277C26.8135 54.2287 23.4223 52.7278 20.8606 50.8037C19.3936 49.6752 17.9886 48.5467 16.6513 47.3336C16.325 47.0426 15.9247 46.8474 15.4946 46.7693C14.9673 46.6482 14.414 46.7235 13.9383 46.9811C13.4625 47.2387 13.097 47.6609 12.9103 48.1687C12.4279 49.3389 12.3407 50.6346 12.662 51.8589C13.4689 54.9453 15.551 57.2926 20.5164 57.7384",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 58.7363C12.6089 59.6801 12.9697 60.5791 13.5716 61.3093C15.1403 63.2052 18.9659 64.2434 22.5489 63.6848",
    fill: "#FAFFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 58.7363C12.6089 59.6801 12.9697 60.5791 13.5716 61.3093C15.1403 63.2052 18.9659 64.2434 22.5489 63.6848",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.5471 33.7259C72.9606 33.2011 81.1649 40.4969 86.7227 49.2146C87.5296 50.4729 88.2688 51.7763 88.9515 53.1079C89.3127 53.8133 89.6625 54.5299 90.0067 55.2465C94.2273 64.0262 97.342 73.8047 94.7069 83.7412C90.4581 99.6757 75.5562 102.852 58.3296 103.123C55.3152 103.18 52.3084 102.8 49.4031 101.995C46.6925 101.258 44.1278 100.063 41.8195 98.4625C34.8341 93.4745 31.663 86.0095 31.0028 78.7419C30.2072 69.618 32.5602 63.2588 36.019 54.9023C38.8798 47.9789 45.0076 40.0229 52.3259 36.1352C54.8506 34.725 57.6606 33.9015 60.5471 33.7259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M77.2444 38.7383C81.025 41.6169 84.2392 45.1716 86.7238 49.2221C87.5307 50.4804 88.2698 51.7838 88.9526 53.1154C89.3137 53.8207 89.6635 54.5373 90.0077 55.2539C94.2283 64.0337 97.343 73.8122 94.708 83.7487C90.4591 99.6832 68.8709 105.54 50.6963 102.307",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M56.2705 34.466C57.6604 34.0447 59.0969 33.7964 60.5475 33.7269C64.7097 33.5091 68.863 34.2968 72.6564 36.0234",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M41.8184 98.4429C24.4507 86.0294 30.1327 59.3459 41.7676 45.0929C44.2183 42.0403 47.1334 39.3918 50.4063 37.2441",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M53.9729 58.8941C54.0017 59.2254 53.9322 59.5579 53.7731 59.8499C53.6141 60.142 53.3725 60.3808 53.0786 60.5364C52.7847 60.692 52.4514 60.7576 52.1205 60.725C51.7895 60.6924 51.4755 60.563 51.2176 60.353C50.9597 60.143 50.7694 59.8616 50.6704 59.5441C50.5715 59.2266 50.5682 58.887 50.6611 58.5677C50.754 58.2483 50.9389 57.9634 51.1927 57.7485C51.4465 57.5336 51.758 57.3982 52.0883 57.3593C52.3134 57.3328 52.5416 57.3517 52.7593 57.415C52.9769 57.4783 53.1797 57.5847 53.3554 57.7278C53.5312 57.871 53.6764 58.048 53.7825 58.2483C53.8886 58.4486 53.9533 58.6682 53.9729 58.8941Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5723 58.8052C64.5723 58.8052 65.334 56.7457 67.7659 57.5865Z",
    fill: "#FFF8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5723 58.8052C64.5723 58.8052 65.334 56.7457 67.7659 57.5865",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M65.178 65.1146C64.5984 64.2047 63.77 63.4802 62.7912 63.0267C61.8124 62.5732 60.7241 62.4098 59.6552 62.5559C58.5864 62.702 57.5818 63.1514 56.7605 63.8509C55.9393 64.5504 55.3358 65.4706 55.0215 66.5026C56.15 68.5791 58.4803 70.853 60.7374 70.5427C62.9944 70.2323 64.6533 67.4111 65.1611 65.1146H65.178Z",
    fill: "#FFAFA7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M107.466 85.5344C106.379 85.601 105.293 85.3875 104.312 84.9142C103.331 84.441 102.488 83.724 101.863 82.8317C101.608 82.4731 101.269 82.1826 100.875 81.9859C100.482 81.7891 100.046 81.692 99.6062 81.7032C98.6429 81.7157 97.6896 81.5076 96.8192 81.0949C95.9487 80.6821 95.1843 80.0757 94.5843 79.322C94.215 78.8802 93.9898 78.3359 93.9388 77.7623C93.8878 77.1887 94.0136 76.6133 94.2993 76.1133C94.5849 75.6132 95.0167 75.2126 95.5367 74.9651C96.0567 74.7177 96.6399 74.6353 97.2081 74.729C101.729 75.5499 105.937 77.5975 109.373 80.648C109.787 81.0332 110.076 81.5338 110.202 82.0849C110.328 82.6361 110.285 83.2124 110.079 83.739C109.874 84.2657 109.515 84.7184 109.049 85.0385C108.583 85.3587 108.032 85.5315 107.466 85.5344Z",
    fill: "#FAFFE6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5176 81.2801C94.6512 81.0544 91.1529 74.9717 90.961 66.4967C90.9134 65.9062 90.9993 65.3125 91.2122 64.7597C91.4251 64.2069 91.7597 63.709 92.1911 63.303C93.2519 62.4002 94.781 62.293 96.1409 62.4058C100.503 62.7557 104.165 64.8096 107.076 68.0145C109.305 70.4634 111.026 73.7417 113.13 76.1623C114.332 77.5504 115.579 78.8764 116.877 80.1121C117.199 80.4193 117.43 80.81 117.543 81.2406C117.695 81.7586 117.656 82.3138 117.433 82.8055C117.21 83.2972 116.819 83.6929 116.33 83.9208C115.194 84.4815 113.906 84.6559 112.662 84.4173C109.525 83.8531 107.02 81.912 106.252 76.9918",
    fill: "#FAFFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5176 81.2801C94.6512 81.0544 91.1529 74.9717 90.961 66.4967C90.9134 65.9062 90.9993 65.3125 91.2122 64.7597C91.4251 64.2069 91.7597 63.709 92.1911 63.303C93.2519 62.4002 94.781 62.293 96.1409 62.4058C100.503 62.7557 104.165 64.8096 107.076 68.0145C109.305 70.4634 111.026 73.7417 113.13 76.1623C114.332 77.5504 115.579 78.8764 116.877 80.1121C117.199 80.4193 117.43 80.81 117.543 81.2406C117.695 81.7586 117.656 82.3138 117.433 82.8055C117.21 83.2972 116.819 83.6929 116.33 83.9208C115.194 84.4815 113.906 84.6559 112.662 84.4173C109.525 83.8531 107.02 81.912 106.252 76.9918",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.76 85.0087C104.818 85.0051 103.9 84.7116 103.131 84.168C101.128 82.7348 99.8302 78.9882 100.14 75.377",
    fill: "#FAFFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.76 85.0087C104.818 85.0051 103.9 84.7116 103.131 84.168C101.128 82.7348 99.8302 78.9882 100.14 75.377",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M80.2516 40.0229C80.2516 40.0229 79.9074 21.064 59.7297 21.9668C39.5521 22.8696 40.8499 41.7551 40.8499 41.7551",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M59.7024 21.9512C57.953 22.0186 56.2143 22.2567 54.5112 22.6621C53.6195 22.8857 52.7431 23.1665 51.8875 23.5029C39.9028 28.1749 40.8507 41.7508 40.8507 41.7508",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M79.3955 35.1638C78.1429 30.7852 74.9944 24.7307 67.123 22.6543",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M61.0156 20.6493L58.2704 20.7702C57.4204 20.8076 56.7618 21.5269 56.7992 22.3768L57.0763 28.6734C57.1137 29.5233 57.833 30.182 58.6829 30.1446L61.4282 30.0238C62.2781 29.9864 62.9368 29.2671 62.8994 28.4171L62.6223 22.1205C62.5849 21.2706 61.8655 20.6119 61.0156 20.6493Z",
    fill: "#FFF9CF",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M50.585 28.5312L50.7317 31.8321",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M69.3438 27.1875L69.513 31.0018",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M60.4377 38.6621C49.5928 39.1361 43.8995 40.7385 41.0331 41.7316C40.5056 41.9125 40.0507 42.2592 39.7365 42.7199C39.4222 43.1806 39.2654 43.7305 39.2895 44.2877C39.3094 44.6759 39.4166 45.0546 39.6032 45.3956C39.7897 45.7367 40.0508 46.0312 40.367 46.2573C40.6831 46.4835 41.0462 46.6354 41.4292 46.7018C41.8122 46.7681 42.2053 46.7472 42.5791 46.6406C45.9646 45.687 52.0416 44.4287 60.6747 44.0507C69.3077 43.667 75.475 44.3836 78.9282 45.0381C79.3116 45.1118 79.7066 45.0977 80.0837 44.9968C80.4608 44.896 80.8101 44.711 81.1055 44.4558C81.4009 44.2006 81.6346 43.8818 81.7892 43.5234C81.9437 43.1649 82.015 42.7761 81.9978 42.3861C81.9746 41.8276 81.7706 41.2917 81.4165 40.8592C81.0623 40.4267 80.5772 40.1209 80.0342 39.9881C77.0888 39.2489 71.277 38.1599 60.4377 38.6395V38.6621Z",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M50.7269 39.5141C47.4304 39.9317 44.1833 40.6745 41.0331 41.7316C40.5056 41.9125 40.0507 42.2592 39.7365 42.7199C39.4222 43.1806 39.2654 43.7305 39.2895 44.2877C39.3094 44.6759 39.4166 45.0546 39.6032 45.3956C39.7897 45.7367 40.0508 46.0312 40.367 46.2573C40.6831 46.4835 41.0462 46.6354 41.4292 46.7018C41.8122 46.7681 42.2053 46.7472 42.5791 46.6406C45.9646 45.687 52.0416 44.4287 60.6747 44.0507C69.3077 43.667 75.475 44.3836 78.9282 45.0381C79.3116 45.1118 79.7066 45.0977 80.0837 44.9968C80.4608 44.896 80.8101 44.711 81.1055 44.4558C81.4009 44.2006 81.6346 43.8818 81.7892 43.5234C81.9437 43.1649 82.015 42.7761 81.9978 42.3861C81.9746 41.8276 81.7706 41.2917 81.4165 40.8592C81.0623 40.4267 80.5772 40.1209 80.0342 39.9881C77.0888 39.2489 71.277 38.1599 60.4377 38.6395C58.7374 38.7147 57.1613 38.8144 55.7093 38.9386",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M23.9736 101.514L16.9035 75.1973H15.3687H13.834L6.76953 101.514",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M20.9983 101.879H27.3631V106.822H3.37109V101.879H14.4699",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M11.4697 85.2461H19.3241",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M9.54883 92.6035H21.5787",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M96.6483 101.879H72.6562V106.822H96.6483V101.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M79.1094 92.289L80.994 85.6816H88.7468L89.9994 92.289H79.1094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M80.6562 84.9564L83.3872 75.6406H86.0674L88.4599 84.9564H80.6562Z",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M78.5539 93.0564L76.5508 101.238H92.6038L90.454 92.7969L78.5539 93.0564Z",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M93.2587 101.514L86.1943 75.1973H84.6539H83.1191L76.0547 101.514",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M86.8867 101.879H96.6483V106.822H72.6562V101.879H80.6573",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M80.7529 85.2461H88.6073",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M78.834 92.6035H90.8638",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8879 45.3904L27.8207 66.8095L23.2559 67.6445L17.7432 37.5812L22.3023 36.7461L22.9343 40.188",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8879 45.3904L27.8207 66.8095L23.2559 67.6445L17.7432 37.5812L22.3023 36.7461L22.9343 40.188",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M18.3353 42.7194C26.4843 42.7194 33.0905 36.1132 33.0905 27.9642C33.0905 19.8151 26.4843 13.209 18.3353 13.209C10.1862 13.209 3.58008 19.8151 3.58008 27.9642C3.58008 36.1132 10.1862 42.7194 18.3353 42.7194Z",
    fill: "#FFF9CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M20.2266 38.2591C18.1903 38.6337 16.0888 38.3959 14.1877 37.5759C12.2866 36.7559 10.6714 35.3906 9.54635 33.6525C8.42132 31.9145 7.83701 29.8818 7.86733 27.8116C7.89765 25.7415 8.54124 23.7268 9.71669 22.0224C10.8921 20.3181 12.5466 19.0006 14.4709 18.2367C16.3952 17.4727 18.5028 17.2966 20.5272 17.7306C22.5516 18.1646 24.4018 19.1892 25.8438 20.6749C27.2858 22.1606 28.2548 24.0405 28.6283 26.0769C29.1242 28.8059 28.5185 31.6202 26.9437 33.9034C25.369 36.1867 22.9536 37.753 20.2266 38.2591Z",
    fill: "white",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M12.5176 36.3931L24.1525 19.5332",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M4.07812 24.1367C4.94158 20.8954 6.88369 18.045 9.58431 16.0554C12.2849 14.0658 15.5829 13.0558 18.9345 13.1918C22.2861 13.3279 25.4913 14.6018 28.0218 16.8038C30.5523 19.0057 32.2571 22.0041 32.855 25.3047",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M32.4007 32.4343C31.4007 35.5693 29.3819 38.2803 26.6648 40.1367C23.9477 41.993 20.6883 42.8882 17.4042 42.6801C14.1202 42.4719 10.9998 41.1724 8.53888 38.9879C6.07791 36.8034 4.41746 33.8592 3.82129 30.623",
    stroke: "#868686",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverhaulDuei);
export default __webpack_public_path__ + "static/media/OverhaulDuei.bf4cf388c790de1a21ee527f4dc4b564.svg";
export { ForwardRef as ReactComponent };